export const CircleInfoStrong = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00004 1.33331C4.31814 1.33331 1.33337 4.31808 1.33337 7.99998C1.33337 11.6819 4.31814 14.6666 8.00004 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00004 1.33331ZM6.66671 7.33331C6.66671 6.96512 6.96518 6.66665 7.33337 6.66665H8.00004C8.36823 6.66665 8.66671 6.96512 8.66671 7.33331V10.6666C8.66671 11.0348 8.36823 11.3333 8.00004 11.3333C7.63185 11.3333 7.33337 11.0348 7.33337 10.6666V7.99998C6.96518 7.99998 6.66671 7.7015 6.66671 7.33331ZM8.00004 4.66665C7.63185 4.66665 7.33337 4.96512 7.33337 5.33331C7.33337 5.7015 7.63185 5.99998 8.00004 5.99998C8.36823 5.99998 8.66671 5.7015 8.66671 5.33331C8.66671 4.96512 8.36823 4.66665 8.00004 4.66665Z"
      fill="currentColor"
    />
  </svg>
)

export default CircleInfoStrong
